module.exports = __webpack_public_path__ + "media/successnotification.b9823fac.mp3";